import { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export function InstallButton({ variant = "sidebar" }) {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setVisible(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const onInstalled = () => setVisible(false);
    window.addEventListener("appinstalled", onInstalled);
    if (isIOS()) setVisible(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!visible) return null;

  const handleClick = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
      setVisible(false);
    } else if (isIOS()) {
      setIosHelp(true);
    }
  };

  const cls = variant === "sidebar"
    ? "w-full border-white/30 text-white hover:bg-white/10 bg-transparent"
    : "border-[#F7941E] text-[#F7941E] hover:bg-[#F7941E] hover:text-white bg-transparent";

  return (
    <>
      <Button variant="outline" size="sm" onClick={handleClick} className={cls} data-testid="install-app-btn">
        <Download className="w-3.5 h-3.5 mr-2"/> Installa app
      </Button>
      <Dialog open={iosHelp} onOpenChange={setIosHelp}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Installa su iPhone / iPad</DialogTitle>
            <DialogDescription>Aggiungi ISTEFORM alla schermata Home in 2 passaggi.</DialogDescription>
          </DialogHeader>
          <ol className="text-sm text-stone-700 space-y-2 list-decimal pl-5">
            <li>Tocca l'icona <Share className="inline w-4 h-4 text-[#1F4E79]"/> <b>Condividi</b> nella barra di Safari.</li>
            <li>Scegli <b>“Aggiungi alla schermata Home”</b> e conferma.</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
}
